export const SESSION_CODE = [...crypto.getRandomValues(new Uint8Array(20))]
  .map((b) => (b % 36).toString(36))
  .join("");
